import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-magma-dom';

import Content from './Content';


const UploadDatasetModalComponent = props => {
  const { isOpen, onCloseModal, onFileChange, isErrorType } = props;
  return (
    <Modal
      isOpen={isOpen}
      onClose={onCloseModal}
      header="Upload Custom Dataset"
      testId="uploadCustomDataset"
    >
      <Content onFileChange={onFileChange} onClose={onCloseModal} isErrorType={isErrorType} />
    </Modal>
  );
};

UploadDatasetModalComponent.propTypes = {
  isErrorType: PropTypes.bool,
  isOpen: PropTypes.bool.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  onFileChange: PropTypes.func.isRequired
};

export default UploadDatasetModalComponent;

